import React from 'react';

/**
 * Approach — "Unsere Methode" — vier Arbeitsgrundsaetze im Zweispalter.
 * Auto-numbered when inside `.numbered-sections`.
 * Section element has id="ansatz" so it remains a valid scroll target.
 *
 */
export default function Approach() {
  const pillars = [
    {
      title: 'Vollständige Übernahme',
      body: 'Wir werden zum zentralen Ansprechpartner für alle: Mieter, Handwerker, Versorger, Behörden, Banken. Sie hören von Ihrer Immobilie nur noch dann, wenn es eine echte Eigentümerentscheidung gibt.',
      n: 'i.',
    },
    {
      title: 'Datenbasierte Steuerung',
      body: 'Wir verwalten kein Bauchgefühl, sondern Zahlen. Performance, Cashflow, Sanierungsstand und Mietpreisniveau Ihres Objekts behalten wir jederzeit in unserer selbst entwickelten Software im Blick.',
      n: 'ii.',
    },
    {
      title: 'Systematische Renditesteigerung',
      body: 'Mieten auf Marktniveau, Rückstände konsequent eingefordert, Leerstände beseitigt, ungenutzte Potenziale erschlossen. Im Schnitt heben wir den Cashflow eines übernommenen Objekts in den ersten zwölf Monaten um zweistellige Prozentsätze.',
      n: 'iii.',
    },
    {
      title: 'Ein Ansprechpartner',
      body: 'Kein Call Center, keine Sachbearbeiter-Rotation. Pro Mandat ein verantwortlicher Mandatsleiter mit operativer Vollmacht und Entscheidungskompetenz. Ihr Vermögen verdient Kontinuität.',
      n: 'iv.',
    },
  ];

  return (
    <section id="ansatz" style={{ padding: '140px 0' }}>
      <div className="shell">
        <div className="section-label numbered reveal" style={{ marginBottom: 28 }}>
          <span>Unsere Methode</span>
        </div>
        <h2 className="h-section reveal" style={{ marginBottom: 80, maxWidth: '20ch' }}>
          Wie wir arbeiten.
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 0,
            borderTop: '1px solid var(--cream-line)',
          }}
        >
          {pillars.map((p, i) => (
            <div
              key={i}
              className="reveal"
              style={{
                padding: '44px 40px 44px 0',
                borderBottom: '1px solid var(--cream-line)',
                borderRight: i % 2 === 0 ? '1px solid var(--cream-line)' : 'none',
                paddingLeft: i % 2 === 0 ? 0 : 40,
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--serif)',
                  fontStyle: 'italic',
                  fontSize: 14,
                  color: 'var(--charcoal-faint)',
                  marginBottom: 18,
                }}
              >
                {p.n}
              </div>
              <h3 className="h-pillar" style={{ marginBottom: 16 }}>
                {p.title}
              </h3>
              <p className="body-prose">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
